/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext, useEffect, MouseEvent, useState, useRef } from "react";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";

import CoPayModal from "../modals/copayModal";
import DropdownPossibleNextStep from "../dropdownPossibleNextStep";
import DropdownStatusColorMeaning from "../dropdownStatusColorMeaning";

import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import useLogout from "src/hooks/useLogout";

import { LogoBrand } from "src/assets";
import { AUTH_RESOURCE_HEADER, AUTH_RESOURCE_HEADER_MANUFACTURE, AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType, ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ResetDemoCasesAPISuccessResponseType } from "./types";
import flexionTour from "src/constants/tour";
import { createUserAPIResponseType, resourceAnalyticsAPIResponse } from "src/pages/createUser/types";
import { ACCESS_TO_LOCAL_COVERAGE_REPORT, getReportsByRole, redirectPath, USER_TYPES } from "src/constants";
import { PHONE_NUMBER } from "src/constants/contact";
import { isZilrettaUser } from "src/helpers";



const AuthHeader: FC = (): JSX.Element => {
    const navigate = useNavigate();
    const { userData, updateUserData, isManufacturer, isUserAuthorized, destroySession } = useContext(AuthContext);
    const { hideLoader } = useContext(LoaderContext);
    const { showToast } = useContext(ToastContext);
    const isSingleSignOn = localStorage.getItem("fromSingleSignOn")
    const dropdowns = useRef<HTMLUListElement>(null)
    const { pathname } = useLocation()

    const { logoutUser } = useLogout()

    // console.log("condition: ", process.env.REACT_APP_ENV)
    const [openSubmenus, setOpenSubmenus] = useState<number[]>([]);
    const [showCoPayModal, updateVisibilityOfCopay] = useState<boolean>(false)

    const autoCollapseSubmenu = (event: MouseEvent<HTMLAnchorElement>, submenuIndex: number) => {
        // Check if clicked element is the dropdown toggle
        if ((event.target as HTMLAnchorElement).matches('a.dropdown-item.dropdown-toggle')) {
            event.stopPropagation(); // Prevent parent dropdown from collapsing
            setOpenSubmenus((prevState) => {
                const isAlreadyOpen = prevState.includes(submenuIndex);

                if (isAlreadyOpen) {
                    // Close the submenu
                    return prevState.filter((index) => index !== submenuIndex);
                } else {
                    // Close all other submenus and open the clicked one
                    return [submenuIndex];
                }
            });
        }
    };

    const { data: resourseAnalyticsResponse, mutate: resourseAnalyticsMutate } =
        useFetch<resourceAnalyticsAPIResponse>(APIEndpoints.RESOURCE_ANALYTICS, {}, { userId: userData?.id });

    useEffect(() => {
        if (resourseAnalyticsResponse && resourseAnalyticsResponse.code === 200) {

            // updateUserData({ ...userData, ...resourseAnalyticsResponse.status.data.user });
            //setTimeout(() => navigate(0), 300)
            // console.log("Api Response Successful")

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resourseAnalyticsResponse]);

    const clickOnResources = (product: string, resources: string) => {
        //console.log("Click On Resources.......",product,"     dfgsdfgsdgsdfgsdfgf",resources);
        const params = {
            product: product === "iovera Resources" ? 'iovera' : 'zilretta',
            resource: resources,
            clicked_at: new Date(),
            clicked_by: userData?.name,
            clicked_by_id: userData?.id
        }
        resourseAnalyticsMutate({}, {}, params)
    }




    const { data: updateUserApiResponse, error, mutate: addNewUser, removeErrorAndData } =
        useFetch<createUserAPIResponseType>(APIEndpoints.USER_UPDATE, {}, { userId: userData?.id });

    useEffect(() => {
        if (updateUserApiResponse) {
            if ((updateUserApiResponse as unknown as { code: number; }).code === 401) {
                destroySession()
                showToast(["Your session has expired. Please sign in again to continue"], ToastTypes.INFO)
                navigate('/users/sign_in')
            }
            if (updateUserApiResponse.status && updateUserApiResponse.status.data && updateUserApiResponse.status.data.user) {
                updateUserData({
                    ...userData,
                    ...updateUserApiResponse.status.data.user,
                    reset_demo_cases: updateUserApiResponse.status.data.navbar?.reset_demo_cases,
                    stats_view: updateUserApiResponse.status.data.navbar?.stats_view,
                    demo_user_view: updateUserApiResponse.status.data.navbar?.demo_user_view,
                    eob_button: updateUserApiResponse.status.data.navbar.eob_button,
                });
                const { user } = updateUserApiResponse.status.data;
                if (USER_TYPES.HCP.includes(user.ref_type))
                    setTimeout(() => navigate("/cases"), 300)
                else
                    setTimeout(() => navigate(redirectPath(user)), 300)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateUserApiResponse]);

    const submitForm = async (values: unknown) => {
        if ((error && error.length > 0) || updateUserApiResponse) removeErrorAndData();
        addNewUser({ user: values });
    };


    const { mutate: resetDemoCasesApi, data: resetDemoCasesApiResponse, error: resetDemoCasesApiResponseError } =
        useFetch<ResetDemoCasesAPISuccessResponseType>(APIEndpoints.DEMO_RESET_CASES);

    useEffect(() => {
        if (resetDemoCasesApiResponse?.status === 'success' || resetDemoCasesApiResponseError) {
            hideLoader();
            if (resetDemoCasesApiResponse?.status === 'success') {
                showToast([resetDemoCasesApiResponse.message], ToastTypes.SUCCESS);
                if (window.location.pathname === "/cases") {
                    navigate(0)
                } else {
                    navigate('/cases');
                }
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetDemoCasesApiResponse, resetDemoCasesApiResponseError]);


    return (
        <>
            <nav className="navbar top-head bg-primary">
                <div className="container-fluid">
                    <ul className="navbar-nav justify-content-center justify-content-lg-end">
                        {isManufacturer ?
                        AUTH_RESOURCE_HEADER_MANUFACTURE.map((headerLink, index) => (
                            <li
                                className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                                key={index}
                            >
                                {headerLink.actionType === HeaderElementType.ROUTE ? (
                                    <NavLink
                                        className={({ isActive }) => {
                                            return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                                        }}
                                        aria-current="page"
                                        to={headerLink.redirectLink}
                                        data-tour={headerLink.title === "Submit Request" ? "fifth-step" : ""}
                                        end
                                    >
                                        {headerLink.title}{' '}
                                    </NavLink>
                                ) : null}
                                {headerLink.actionType === HeaderElementType.BUTTON ?
                                    ((headerLink.title === 'EOB Warehouse' ?
                                        (userData && userData.eob_button ?
                                            <button className="nav-link btn-localCoverage rounded-pill ms-0 ms-md-2"
                                                onClick={() => {
                                                    navigate(headerLink.redirectLink)
                                                }}>
                                                {headerLink.title}
                                            </button>
                                            : null)
                                        :
                                        (<button className="nav-link btn-localCoverage rounded-pill ms-0 ms-md-2"
                                            onClick={() => {
                                                navigate(headerLink.redirectLink)
                                            }}>
                                            {headerLink.title}
                                        </button>)
                                    ))
                                    : null}

                                {headerLink.actionType === HeaderElementType.LINK ? (
                                    <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                                        {headerLink.title}
                                    </a>
                                ) : null}
                                {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                                    <>
                                        <a className="nav-link dropdown-toggle" href="."
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            {headerLink.title}
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-start dropdown-menu-lg-end shadow">
                                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                                                return header.dropdown && header.dropdown.length > 0 ?
                                                    ((header.title === "iovera Resources" && !(isZilrettaUser(userData)))
                                                        ?
                                                        <li className="submenu submenu-md dropend" key={index}>
                                                            <a className="dropdown-item dropdown-toggle" role="button"
                                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                                onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                href="."
                                                            >
                                                                {header.title}
                                                            </a>
                                                            <ul className={`shadow dropdown-menu py-2 ${openSubmenus.includes(index) ? 'show' : 'xs-d-none'}`}>
                                                                {header.dropdown.map((dropdown, index) => (
                                                                    <li className="px-0" key={index}>
                                                                        <a className="dropdown-item" href={dropdown.redirectLink}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}>
                                                                            {dropdown.title}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                        :
                                                        (header.title === "ZILRETTA Resources" && <li className="submenu submenu-md dropend" key={index}>
                                                            <a className="dropdown-item dropdown-toggle" role="button"
                                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                                onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                href="."
                                                            >
                                                                {header.title}
                                                            </a>
                                                            <ul className={`shadow dropdown-menu py-2 ${openSubmenus.includes(index) ? 'show' : 'xs-d-none'}`}>
                                                                {header.dropdown.map((dropdown, index) => (
                                                                    <li className="px-0" key={index}>
                                                                        <a className="dropdown-item" href={dropdown.redirectLink}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}>
                                                                            {dropdown.title}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>)
                                                    )
                                                    :
                                                    (
                                                        <li key={index}>
                                                            <a className="dropdown-item" href={header.redirectLink} target="_blank"
                                                                rel="noreferrer">
                                                                {header.title}
                                                            </a>
                                                        </li>
                                                    );
                                            })}
                                        </ul>
                                    </>
                                ) : null}
                            </li>
                        )) : 
                        AUTH_RESOURCE_HEADER.map((headerLink, index) => (
                            <li
                                className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                                key={index}
                            >
                                {headerLink.actionType === HeaderElementType.ROUTE ? (
                                    <NavLink
                                        className={({ isActive }) => {
                                            return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                                        }}
                                        aria-current="page"
                                        to={headerLink.redirectLink}
                                        data-tour={headerLink.title === "Submit Request" ? "fifth-step" : ""}
                                        end
                                    >
                                        {headerLink.title}{' '}
                                    </NavLink>
                                ) : null}
                                {headerLink.actionType === HeaderElementType.BUTTON ?
                                    ((headerLink.title === 'EOB Warehouse' ?
                                        (userData && userData.eob_button ?
                                            <button className="nav-link btn-localCoverage rounded-pill ms-0 ms-md-2"
                                                onClick={() => {
                                                    navigate(headerLink.redirectLink)
                                                }}>
                                                {headerLink.title}
                                            </button>
                                            : null)
                                        :
                                        (<button className="nav-link btn-localCoverage rounded-pill ms-0 ms-md-2"
                                            onClick={() => {
                                                navigate(headerLink.redirectLink)
                                            }}>
                                            {headerLink.title}
                                        </button>)
                                    ))
                                    : null}

                                {headerLink.actionType === HeaderElementType.LINK ? (
                                    <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                                        {headerLink.title}
                                    </a>
                                ) : null}
                                {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                                    <>
                                        <a className="nav-link dropdown-toggle" href="."
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            {headerLink.title}
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-start dropdown-menu-lg-end shadow">
                                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                                                return header.dropdown && header.dropdown.length > 0 ?
                                                    ((header.title === "iovera Resources" && !(isZilrettaUser(userData)))
                                                        ?
                                                        <li className="submenu submenu-md dropend" key={index}>
                                                            <a className="dropdown-item dropdown-toggle" role="button"
                                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                                onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                href="."
                                                            >
                                                                {header.title}
                                                            </a>
                                                            <ul className={`shadow dropdown-menu py-2 ${openSubmenus.includes(index) ? 'show' : 'xs-d-none'}`}>
                                                                {header.dropdown.map((dropdown, index) => (
                                                                    <li className="px-0" key={index}>
                                                                        <a className="dropdown-item" href={dropdown.redirectLink}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}>
                                                                            {dropdown.title}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>
                                                        :
                                                        (header.title === "ZILRETTA Resources" && <li className="submenu submenu-md dropend" key={index}>
                                                            <a className="dropdown-item dropdown-toggle" role="button"
                                                                data-bs-toggle="dropdown" aria-expanded="false"
                                                                onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                href="."
                                                            >
                                                                {header.title}
                                                            </a>
                                                            <ul className={`shadow dropdown-menu py-2 ${openSubmenus.includes(index) ? 'show' : 'xs-d-none'}`}>
                                                                {header.dropdown.map((dropdown, index) => (
                                                                    <li className="px-0" key={index}>
                                                                        <a className="dropdown-item" href={dropdown.redirectLink}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}>
                                                                            {dropdown.title}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </li>)
                                                    )
                                                    :
                                                    (
                                                        <li key={index}>
                                                            <a className="dropdown-item" href={header.redirectLink} target="_blank"
                                                                rel="noreferrer">
                                                                {header.title}
                                                            </a>
                                                        </li>
                                                    );
                                            })}
                                        </ul>
                                    </>
                                ) : null}
                            </li>
                        ))
                        }
                        <DropdownStatusColorMeaning />
                        <DropdownPossibleNextStep />
                        {window.location.pathname === "/cases" && (
                            <li className="nav-item d-none d-lg-flex">
                                <button onClick={() => flexionTour.start()} className="nav-link" type="button">
                                    Take a Tour
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg py-2 py-lg-3">
                <div className="container-fluid">
                    <Link className="navbar-brand" style={{minWidth:'90px'}}
                        to={isUserAuthorized ?
                            (userData?.is_password_changed || isSingleSignOn ?
                                (isManufacturer ? (userData ? redirectPath(userData) : "") : `/cases`) :
                                '/users/createuser'
                            ) :
                            `/users/sign_in`
                        }
                        reloadDocument
                    >
                        <img src={LogoBrand} alt="Flexion Logo" />
                    </Link>
                    <button className="navbar-toggler bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse justify-content-start" id="authHeader">
                        <ul className="navbar-nav me-auto first-nav gap-2 gap-lg-0 mb-2 mb-lg-0 align-items-start align-items-lg-center">
                            {(userData && userData.is_password_changed) || isSingleSignOn ? (
                                <>
                                    {isManufacturer === true ?
                                        AuthenticatedManufactureHeader.map((headerLink, index) => (
                                            <li
                                                className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                                                key={index}
                                            >
                                                {headerLink.actionType === HeaderElementType.ROUTE ? (
                                                    ((headerLink.title === "Action Dashboard") ?
                                                        (
                                                            //process.env.REACT_APP_ENV !== 'production' ?
                                                            <NavLink
                                                                className={({ isActive }) => {
                                                                    return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                                                                }}
                                                                aria-current="page"
                                                                to={
                                                                    headerLink.redirectLink}
                                                                end
                                                            >
                                                                {

                                                                    headerLink.title}
                                                            </NavLink>
                                                           // : <> </>
                                                        )
                                                        : (<NavLink
                                                            className={({ isActive }) => {
                                                                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                                                            }}
                                                            aria-current="page"
                                                            to={headerLink.title === "Statistics" ? (userData ? redirectPath(userData) : "") :

                                                                headerLink.redirectLink}
                                                            end
                                                        >
                                                            {

                                                                headerLink.title}
                                                        </NavLink>)
                                                    )
                                                    ) : null}
                                                {headerLink.actionType === HeaderElementType.BUTTON ? (
                                                    headerLink.title === 'EOB Warehouse'
                                                        ? (userData?.ref_type === 'fam_rm' || userData?.ref_type === 'fam_am' || userData?.eob_button) && (
                                                            <button className="btn btn-EOB"
                                                                onClick={() => navigate(headerLink.redirectLink)}
                                                            >
                                                                {headerLink.title}
                                                            </button>
                                                        )
                                                        : (
                                                            <button className="btn btn-localCoverage"
                                                                onClick={() => navigate(headerLink.redirectLink)}
                                                            >
                                                                {headerLink.title}
                                                            </button>
                                                        )

                                                ) : null}
                                                {headerLink.actionType === HeaderElementType.LINK ? (
                                                    <a className="nav-link" href={headerLink.redirectLink} target="_blank"
                                                        rel="noreferrer">
                                                        {headerLink.title}
                                                    </a>
                                                ) : null}
                                                {headerLink.actionType === HeaderElementType.DRPODOWN ? (headerLink.title === "Reports" ?
                                                    (
                                                        <>
                                                            <button
                                                                className={`nav-link dropdown-toggle ${pathname.includes("report") && headerLink.title === "Reports" ? "custom-active-link show" : ""}`}
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                onClick={(e) => {
                                                                    if (e.currentTarget.classList.contains("show")) {
                                                                        e.currentTarget.classList.add("custom-active-link")
                                                                    } else {
                                                                        if (!(pathname.includes("report") && headerLink.title === "Reports"))
                                                                            e.currentTarget.classList.remove("custom-active-link")
                                                                    }
                                                                }}
                                                                onFocus={(e) => e.target.classList.add("custom-active-link")}
                                                                onBlur={(e) => {
                                                                    if (!(pathname.includes("report") && headerLink.title === "Reports")) {
                                                                        e.target.classList.remove("custom-active-link")
                                                                    }
                                                                }}
                                                            >
                                                                {headerLink.title}
                                                            </button>
                                                            <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-center shadow">

                                                                {/* getReportsByRole(userData.ref_type).map() */}
                                                                {
                                                                    //headerLink.dropdown && headerLink.dropdown
                                                                    userData && getReportsByRole(userData).map((header: any, index: number) => (
                                                                        <li key={index}>
                                                                            {headerLink.title === "Reports" ? (
                                                                                header.redirectLink && header.redirectLink !== "/" ? (
                                                                                    <>
                                                                                        {header.title === "Local Coverage Analytics" ?
                                                                                            (ACCESS_TO_LOCAL_COVERAGE_REPORT.includes(userData?.email) ? (
                                                                                                <Link
                                                                                                    to={header.redirectLink}
                                                                                                    className="dropdown-item"
                                                                                                    onClick={() => {
                                                                                                        if (dropdowns && dropdowns.current) {
                                                                                                            dropdowns.current.classList.remove("show")
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    {header.title}
                                                                                                </Link>
                                                                                            ) : null) :
                                                                                            <Link
                                                                                                to={header.redirectLink}
                                                                                                className="dropdown-item"
                                                                                                onClick={() => {
                                                                                                    if (dropdowns && dropdowns.current) {
                                                                                                        dropdowns.current.classList.remove("show")
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                {header.title}
                                                                                            </Link>
                                                                                        }
                                                                                    </>
                                                                                ) : (
                                                                                    <span className="dropdown-item">
                                                                                        {header.title}
                                                                                    </span>
                                                                                )
                                                                            ) : (
                                                                                header.redirectLink && header.redirectLink !== "/" ? (
                                                                                    <a
                                                                                        href={header.redirectLink}
                                                                                        target="_blank"
                                                                                        rel="noreferrer"
                                                                                        className="dropdown-item"
                                                                                    >
                                                                                        {header.title}
                                                                                    </a>
                                                                                ) : (
                                                                                    <span className="dropdown-item">
                                                                                        {header.title}
                                                                                    </span>
                                                                                )
                                                                            )}
                                                                        </li>
                                                                    ))}


                                                            </ul>
                                                        </>
                                                    ) :
                                                    (<>
                                                        <a className="nav-link dropdown-toggle" href="."
                                                            data-bs-toggle="dropdown" aria-expanded="false"
                                                        >
                                                            {headerLink.title}
                                                        </a>
                                                        <ul ref={dropdowns} className="resources-dropdown dropdown-menu dropdown-menu-end">
                                                            {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                                                                return header.dropdown && header.dropdown.length > 0 ?
                                                                    (
                                                                        <>
                                                                            <li className="submenu submenu-md dropend"
                                                                                key={index}>
                                                                                <a className="dropdown-item dropdown-toggle"
                                                                                    role="button"
                                                                                    data-bs-toggle="dropdown" aria-expanded="false"
                                                                                    onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                                    href="."
                                                                                >
                                                                                    {header.title}
                                                                                </a>
                                                                                <ul className={`shadow dropdown-menu py-2${openSubmenus.includes(index) ? ' show' : ' xs-d-none'}`}>
                                                                                    {header.dropdown.map((dropdown, index) => (
                                                                                        <li className="px-0" key={index}>
                                                                                            <a
                                                                                                className="dropdown-item"
                                                                                                href={dropdown.redirectLink}
                                                                                                target="_blank" rel="noreferrer"
                                                                                                onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}
                                                                                            >
                                                                                                {dropdown.title}
                                                                                            </a>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </li></>
                                                                    ) : (
                                                                        <li key={index}>
                                                                            <a className="dropdown-item"
                                                                                href={header.redirectLink} target="_blank"
                                                                                rel="noreferrer">
                                                                                {header.title}
                                                                            </a>
                                                                        </li>
                                                                    )
                                                            })}
                                                        </ul>
                                                    </>)) : null}
                                            </li>
                                        ))
                                        :
                                        <>
                                            {AuthenticatedHCPHeader.map((headerLink, index) => (
                                                <li
                                                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                                                    key={index}
                                                >
                                                    {headerLink.actionType === HeaderElementType.ROUTE ? 
                                                    ((headerLink.title === "Copay Cases") ?
                                                        (
                                                            // process.env.REACT_APP_ENV !== 'production' ?
                                                            (<NavLink
                                                                className={({ isActive }) => {
                                                                    return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                                                                }}
                                                                aria-current="page"
                                                                to={
                                                                    headerLink.redirectLink}
                                                                end
                                                            >
                                                                {

                                                                    headerLink.title}
                                                            </NavLink>)
                                                            // : <> </>
                                                        )
                                                        : (<NavLink
                                                            className={({ isActive }) => {
                                                                return ["nav-link btn-submit", isActive ? "custom-active-link" : ""].join(" ")
                                                            }}
                                                            aria-current="page"
                                                            to={headerLink.redirectLink}
                                                            data-tour={headerLink.title === "Submit Request" ? "fifth-step" : ""}
                                                            end
                                                        >
                                                            {headerLink.title}{' '}
                                                        </NavLink>)
                                                    ):null
                                                    
                                                    
                                                    }
                                                    {headerLink.actionType === HeaderElementType.BUTTON ?
                                                        ((headerLink.title === 'EOB Warehouse' ?
                                                            (userData && userData.eob_button ?
                                                                <button className="btn btn-EOB"
                                                                    onClick={() => {
                                                                        navigate(headerLink.redirectLink)
                                                                    }}>
                                                                    {headerLink.title}
                                                                </button>
                                                                : null)
                                                            :
                                                            (<button className="btn btn-localCoverage"
                                                                onClick={() => {
                                                                    navigate(headerLink.redirectLink)
                                                                }}>
                                                                {headerLink.title}
                                                            </button>)
                                                        ))
                                                        : null}

                                                    {headerLink.actionType === HeaderElementType.LINK ? (
                                                        <a className="nav-link" href={headerLink.redirectLink}
                                                            target="_blank" rel="noreferrer">
                                                            {headerLink.title}
                                                        </a>
                                                    ) : null}
                                                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                                                        <>
                                                            <a className="nav-link dropdown-toggle" href="."
                                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                                {headerLink.title}
                                                            </a>
                                                            <ul className="dropdown-menu dropdown-menu-end dropdown- shadow">
                                                                {headerLink.dropdown && headerLink.dropdown.map((header, index) => {
                                                                    return header.dropdown && header.dropdown.length > 0 ? (
                                                                        <li className="submenu submenu-md dropend"
                                                                            key={index}>
                                                                            <a className="dropdown-item dropdown-toggle"
                                                                                role="button"
                                                                                data-bs-toggle="dropdown"
                                                                                aria-expanded="false"
                                                                                onClick={(event) => autoCollapseSubmenu(event, index)}
                                                                                href="."
                                                                            >
                                                                                {header.title}
                                                                            </a>
                                                                            <ul className={`shadow dropdown-menu py-2 ${openSubmenus.includes(index) ? 'show' : 'xs-d-none'}`}>
                                                                                {header.dropdown.map((dropdown, index) => (
                                                                                    <li className="px-0" key={index}>
                                                                                        <a className="dropdown-item"
                                                                                            href={dropdown.redirectLink}
                                                                                            target="_blank"
                                                                                            rel="noreferrer"
                                                                                            onClick={() => clickOnResources(header.title.toString(), dropdown.title.toString())}>
                                                                                            {dropdown.title}
                                                                                        </a>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </li>
                                                                    ) : (
                                                                        <li key={index}>
                                                                            <a className="dropdown-item"
                                                                                href={header.redirectLink} target="_blank"
                                                                                rel="noreferrer">
                                                                                {header.title}
                                                                            </a>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        </>
                                                    ) : null}
                                                </li>
                                            ))}
                                        </>
                                    }
                                    <li className="nav-item">
                                        <button className="btn btn-copay" onClick={() => updateVisibilityOfCopay(true)}>
                                            Co-Pay Program
                                        </button>
                                    </li>
                                </>
                            ) : null}
                        </ul>

                        <div className="d-flex flex-column flex-lg-row align-items-end align-items-lg-center flex-wrap-reverse justify-content-lg-end">
                            {isManufacturer && (
                                <span><i className="bi bi-telephone"></i> {PHONE_NUMBER} &nbsp;|</span>
                            )}
                            <ul className="navbar-nav">
                                {userData?.is_password_changed || isSingleSignOn ? (
                                    isManufacturer ?
                                        <li className="nav-item dropdown m-0">
                                            <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                                                {userData?.name}
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end shadow account-setting-dropdown">
                                                <li>
                                                    <Link className="dropdown-item" to='/users/updateuser'>
                                                        Account Settings
                                                    </Link>
                                                </li>
                                                {/* i am adding this check for only Manufacture  && !isZilrettaUser(userData.email) */}
                                                {userData && (userData.demo_user_view || userData.stats_view) ? (
                                                    <li>
                                                        <button className="dropdown-item"
                                                            onClick={() => submitForm({ demo: true })}>
                                                            Demo User View
                                                        </button>
                                                    </li>
                                                ) : null}
                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>
                                                <li>
                                                    <button className="dropdown-item"
                                                        onClick={() => logoutUser()}>Logout
                                                    </button>
                                                </li>
                                            </ul>
                                        </li>
                                        :
                                        <>
                                            <li className="nav-item dropdown m-0">
                                                <a className="nav-link dropdown-toggle" href="."
                                                   data-bs-toggle="dropdown">
                                                    {userData?.name}
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-start dropdown-menu-lg-end shadow account-setting-dropdown">
                                                    <li><Link className="dropdown-item" to="/users/updateuser">Account
                                                        Settings</Link></li>
                                                    <li><Link className="dropdown-item" to="/users/new">Add User</Link>
                                                    </li>
                                                    <li><Link className="dropdown-item" to="/doctors/new">Add
                                                        Doctor</Link></li>
                                                    <li><Link className="dropdown-item" to="/pages/baa">BAA</Link></li>
                                                    {userData && userData.reset_demo_cases ? (
                                                        <li><a href="." className="dropdown-item"
                                                            onClick={() => resetDemoCasesApi()}>Reset Demo Cases</a>
                                                        </li>
                                                    ) : null}
                                                    {userData && ((Object.hasOwn(userData, "stats_view") && userData.stats_view === true)) ? (
                                                        <>
                                                            <li>
                                                                <button className="dropdown-item"
                                                                    onClick={() => submitForm({ demo: false })}>Stats
                                                                    View
                                                                </button>
                                                            </li>
                                                        </>
                                                    ) : null}
                                                    <li>
                                                        <hr className="dropdown-divider" />
                                                    </li>
                                                    <li>
                                                        <button className="dropdown-item"
                                                            onClick={() => logoutUser()}>Logout
                                                        </button>
                                                    </li>
                                                </ul>
                                            </li>
                                        </>
                                ) : (
                                    <li className="nav-item dropdown">
                                        <a
                                            className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                                            aria-expanded="false" role="button"
                                        >
                                            {userData?.name}
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-end shadow">
                                            <li>
                                                <button className="dropdown-item" onClick={() => logoutUser()}>Logout
                                                </button>
                                            </li>
                                        </ul>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                <CoPayModal showModal={showCoPayModal} hideModal={() => updateVisibilityOfCopay(false)} />
            </nav>
        </>
    );
};

export default AuthHeader;
